
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.972 3.029c.26.26.26.682 0 .943l-9 9a.667.667 0 01-.943-.943l9-9c.26-.26.682-.26.943 0z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.029 3.029c.26-.26.682-.26.943 0l9 9a.667.667 0 01-.943.943l-9-9a.667.667 0 010-.943z","fill":"#000"}})])
          )
        }
      }
    